import { useMountEffect } from "@react-hookz/web";
import React, { useCallback, useEffect, useRef } from "react";
import { CloseButton } from "~/components/acquisition-popup-container/display/popups/common";
import { PopupBackdrop } from "~/components/acquisition-popup-container/display/styles";
import { useSdkContext } from "~/components/contexts";
import { FollowButtonAction, FollowButtonOutline, FollowButtonSize, FollowButtonVariant, isFollowType } from "~/components/follow-button/enums";
import { Modal } from "~/components/modal";
import { getCTAType, useActionButtonRenderer } from "./helpers";
import { Container, ContentContainer, Description, Image, TagLine, Title } from "./styles";
export const CampaignPopup = ({
  campaign,
  confirmedAction,
  modalContainerReference,
  onClose
}) => {
  const {
    handleFollow,
    handleTrackGA4
  } = useSdkContext();
  const {
    content,
    layout = "default",
    tagline,
    theme
  } = campaign;
  const {
    description,
    image,
    title
  } = content;
  const actionButtonRenderer = useActionButtonRenderer(campaign);
  const handleFollowReference = useRef(handleFollow);
  const handleTrackGA4Reference = useRef(handleTrackGA4);
  const campaignName = campaign.campaign;
  const ctaType = getCTAType(theme);
  useMountEffect(() => {
    if (confirmedAction) return;
    handleTrackGA4({
      action: "imp",
      category: "promopopup",
      customized_parameters: {
        cta_type: ctaType,
        internal_campaign: campaignName,
        step: "1"
      },
      subcategory: ""
    });
  });
  const handleClose = useCallback(() => {
    handleTrackGA4({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: ctaType,
        internal_campaign: campaignName,
        message: "close button",
        step: "1"
      },
      subcategory: ""
    });
    onClose();
  }, [campaignName, ctaType, onClose, handleTrackGA4]);
  useEffect(() => {
    const {
      tid,
      tids = [],
      type
    } = campaign;
    if (!confirmedAction) return;
    if (!handleFollowReference.current) return;
    if (!handleTrackGA4Reference.current) return;
    if (!isFollowType(type)) return;
    handleFollowReference.current({
      action: FollowButtonAction.Follow,
      callback: () => {
        handleTrackGA4Reference.current({
          action: "sys",
          category: "follow",
          customized_parameters: {
            action_type: "follow",
            follow_type: "topic",
            internal_campaign: campaignName,
            topic_id: tid !== null && tid !== void 0 ? tid : tids.join(", "),
            trigger_point: "ppto"
          },
          subcategory: "result"
        });
      },
      entityIds: tid ? [tid] : tids,
      followType: type
    });
    onClose();
  }, [campaign, campaignName, confirmedAction, handleFollowReference, handleTrackGA4Reference, onClose]);
  if (confirmedAction) return null;
  return /*#__PURE__*/React.createElement(Modal, {
    BackdropComponent: PopupBackdrop,
    container: modalContainerReference === null || modalContainerReference === void 0 ? void 0 : modalContainerReference.current,
    fadeTimeout: 400,
    open: true,
    "data-qa": "campaign-popup"
  }, /*#__PURE__*/React.createElement(Container, {
    $variant: layout
  }, /*#__PURE__*/React.createElement(CloseButton, {
    onClose: handleClose
  }), /*#__PURE__*/React.createElement(Image, {
    alt: title,
    src: image
  }), /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(TagLine, {
    dangerouslySetInnerHTML: {
      __html: tagline
    }
  }), /*#__PURE__*/React.createElement(Title, {
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/React.createElement(Description, {
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), actionButtonRenderer.render({
    followButtonProps: {
      outline: layout === "soft" ? FollowButtonOutline.Filled : FollowButtonOutline.Outlined,
      size: layout === "soft" ? FollowButtonSize.Large : FollowButtonSize.Normal,
      variant: layout === "soft" ? FollowButtonVariant.Light : FollowButtonVariant.Dark
    },
    handlePopupClose: onClose
  }))));
};
CampaignPopup.displayName = "CampaignPopup";